function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "#ff754c",
  d: "M32,15v-2c0-1.106-0.896-2-2-2H18c-1.104,0-2,0.894-2,2v2H32z"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fill: "#5ec08f",
  d: "M46,22H31v4h17v-2C48,22.895,47.104,22,46,22z"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  fill: "#7e8ccf",
  d: "M17,19H2c-1.105,0-2,0.895-2,2v2h17V19z"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  fill: "#ffba57",
  d: "M32 25L32 14 16 14 16 22 0 22 0 38 48 38 48 25z"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  fill: "#ffe9b3",
  d: "M25 24h-1.65v-5.172l-1.621.464v-1.23L24.849 17H25V24zM38.654 30.844h.752c.594 0 .892-.289.892-.867 0-.223-.071-.406-.213-.547-.142-.145-.342-.215-.601-.215-.21 0-.394.063-.551.184-.155.121-.233.274-.233.453h-1.593c0-.359.102-.678.303-.957.202-.281.482-.5.839-.66C38.607 28.078 39.001 28 39.43 28c.765 0 1.367.172 1.805.52.438.344.657.82.657 1.426 0 .293-.091.57-.273.83-.181.26-.444.471-.791.635.366.129.652.328.859.594C41.896 32.273 42 32.602 42 32.992c0 .609-.236 1.098-.709 1.461C40.818 34.816 40.198 35 39.43 35c-.451 0-.869-.086-1.256-.254-.385-.172-.678-.406-.876-.707C37.099 33.738 37 33.395 37 33.012h1.602c0 .211.086.391.256.543.17.152.38.23.628.23.28 0 .504-.079.671-.232.168-.154.251-.352.251-.592 0-.344-.087-.586-.261-.73-.172-.141-.412-.215-.717-.215h-.775V30.844zM11 32H6.144v-1.044l2.236-2.332c.551-.621.827-1.117.827-1.484 0-.295-.065-.521-.196-.676-.131-.154-.32-.232-.569-.232-.245 0-.444.103-.597.31-.154.208-.229.465-.229.774H6c0-.422.107-.813.32-1.172.213-.359.51-.641.89-.842C7.59 25.102 8.013 25 8.48 25c.753 0 1.33.172 1.738.516.405.344.609.84.609 1.484 0 .271-.051.535-.152.795-.104.256-.262.525-.477.809-.215.283-.561.662-1.04 1.135L8.261 30.77H11V32z"
});

const SvgPodium = (_ref) => {
  let svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 48 48",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6);
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgPodium, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/podium.542dd028.svg";
export { ForwardRef as ReactComponent };